import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connectToStores} from 'fluxible-addons-react';
import {defineMessages, FormattedMessage} from 'react-intl';
import LinkGroup from '../components/LinkGroup';
import {LinkShape} from '../utils/react/Shapes';
import Immutable from 'immutable';
import FontAwesome from 'react-fontawesome';

const messages = defineMessages({
  welcome: {
    id: 'home.welcome.authenticated',
    defaultMessage: 'Welcome {name}.',
    description: 'A welcome message for an authenticated user when they visit the home page.'
  }
});

@connectToStores(['PortalUserStore', 'FavoriteStore'], (context) => {
  const PortalUserStore = context.getStore('PortalUserStore');
  const FavoriteStore = context.getStore('FavoriteStore');
  const favorites = FavoriteStore.getFavorites().map(favorite => {
    return {
      id: favorite.url,
      url: favorite.url,
      name: favorite.name,
      description: favorite.description,
      imageUrl: favorite.imageUrl,
      favorite: true
    };
  });

  const sortedFavorites = Immutable.fromJS(favorites).sortBy(link => link.get('name').toLowerCase().replace(/\W/g, '')).toJS();

  return {
    name: PortalUserStore.getName(),
    title: PortalUserStore.getTitle(),
    clientName: PortalUserStore.getClientName(),
    favorites: sortedFavorites
  };
})

class AuthenticatedHome extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    clientName: PropTypes.string.isRequired,
    favorites: PropTypes.arrayOf(LinkShape)
  };

  render() {
    const {name, title, clientName, favorites} = this.props;

    const pageTitle = favorites.length ? 'Your Favorites' : '';

    const favoritesSection = favorites.length ?
      <LinkGroup links={ favorites } showFavorite/> :
      <div>
        <p />
        <h4 className="text-center">
          <FontAwesome name="hand-o-up" />&nbsp;Navigate using the links in the top navigation bar.
        </h4>
      </div>;

    return <div className="flex-element flex-container flex-vertical">
      <section className="user-info flex-center">
        <h1>
          <FormattedMessage { ...messages.welcome } values={ {name} }/>
        </h1>
        <h4>
          { title } @ { clientName }
        </h4>
      </section>
      <section className="favorites flex-element flex-container flex-vertical">
        <h2 className="text-center">
          { pageTitle }
        </h2>
        <div className="flex-element scroll-y">
          { favoritesSection }
        </div>
      </section>
    </div>;
  }
}

export default AuthenticatedHome;



// WEBPACK FOOTER //
// ./src/pages/AuthenticatedHome.js